module.exports = __webpack_public_path__ + "img/LUB00144.eb110c83.svg";